import Enums from 'utils/EnumsManager';

const { INVOICE } = Enums.REDUX_ACTION_TYPE_PREFIX;
const ATTACHMENTS = 'ATTACHMENTS';
export const ADD_ATTACHMENT = `${INVOICE}_${ATTACHMENTS}_ADD_ATTACHMENT`;
export const REMOVE_ATTACHMENT = `${INVOICE}_${ATTACHMENTS}_REMOVE_ATTACHMENT`;
export const SET_ATTACHMENTS = `${INVOICE}_${ATTACHMENTS}_SET_ATTACHMENTS`;



// WEBPACK FOOTER //
// ./src/views/Invoice/flow/upload/actionTypes.js